export default __webpack_public_path__ + "static/media/Marina_Alekseevna_Zhunich.c832ec6f.webp";